export const NOTIFICATION_TYPES = {
  FILES: 'FILES',
  BOARDS: 'BOARDS',
  SALES: 'SALES',
  QUOTES: 'QUOTES',
  CTA: 'CTA',
  VIEW: 'VIEW',
  EMAIL_NOT_DELIVERED: 'EMAIL_NOT_DELIVERED',
  MESSAGES: 'MESSAGES',
  REPLY: 'REPLY',
  REACTIONS_COMMENTS: 'REACTIONS_COMMENTS',
  PUSHED_TO_VDP: 'PUSHED_TO_VDP',
  VIDEO_DELETE: 'VIDEO_DELETE',
  LIVE: 'LIVE',
  REPORTS: 'REPORTS',
};

export const RO_APPROVAL_TYPE = {
  ALL_APPROVED: 1,
  ALL_DENIED: 2,
  PARTIALLY_APPROVED: 3,
};
